var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('vue-plyr',{ref:"thePlayer",attrs:{"options":_vm.plyrOptions}},[_c('audio',{attrs:{"id":"playerAudioElement"}},[_c('source',{attrs:{"src":_vm.audio_url,"type":"audio/mp3"}})]),_c('PlyrCSSOverride')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }